import { endOfToday, parseISO } from 'date-fns';
import { format } from 'date-fns-tz';
import {
  LOCAL_DATETIME_FORMAT,
  LOCAL_TIMEZONE,
} from 'lib_ts/enums/datetime.enums';
import { LanguageCode } from 'lib_ts/enums/translation';
import { IErrorType } from 'lib_ts/interfaces/common/i-error-type';

export const MAX_DATE = endOfToday();

// all dates in the MachineErrors section use the format below
export const formatDate = (date?: string) =>
  date
    ? format(parseISO(date), LOCAL_DATETIME_FORMAT, {
        timeZone: LOCAL_TIMEZONE,
      })
    : '';

export const translateUserErrorMessage = (
  type: IErrorType,
  language: LanguageCode | undefined
) => {
  switch (language) {
    case LanguageCode.Korean: {
      return type.user_message_korean || type.user_message;
    }

    case LanguageCode.Japanese: {
      return type.user_message_japanese || type.user_message;
    }

    case LanguageCode.English:
    default: {
      return type.user_message;
    }
  }
};
